import { postRequest } from '~/shared/utils';

export async function resetUserPassword(apiUrl: string, headers?: HeadersInit) {
    const request = await postRequest<boolean>(apiUrl, {}, headers);

    const response = await request();

    return response;
}
